export class TextInputComponent {
  name: string;
  label: string;
  minLength: number;
  maxLength: number;
  isRequired: boolean;
  maxLines: number;
  regexChoice: string;
}
